<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.guide">
  <app-popup-header title="{{localService.languageContent.guide.header}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-sm-7">
        <app-language-single [parentId]="wrapper.content.key" [languageKeyType]="23"
          [isEnglishEditor]="true"></app-language-single>
        <a href="https://onlinehtmleditor.dev/" class="en" target="_blank">HTML Editor</a>&nbsp;
        <button type="button" class="btn btn-primary en" style="float: right;font-family: EnglishFont !important;"
          (click)="onAction(2,wrapper.content.key)" [disabled]="!wrapper.content.key">Update this guide
          content to all the languages</button>
      </div>
      <div class="col-sm-5">
        <div *ngIf="pageKeys" class="en">
          <ngx-select style="width: calc(100% - 30px); float: left;font-family: EnglishFont !important;"
            [(ngModel)]="selectedPageKey" [items]="pageKeys" [optionValueField]="'key'" [optionTextField]="'value'"
            placeholder="{{localService.languageContent.guide.select_page_key}}" (select)="onGetGuide()">
          </ngx-select>
          <i style="float:right;" class="material-icons button icon_adjust"
            *ngIf="selectedPageKey && selectedPageKey != '0-0'" (click)="onDownLoadFile()">file_download</i>
        </div>
        <div>
          <label style="font-weight: normal; padding-left: 30px;">
            <input type="checkbox" [(ngModel)]="isActive" />
            <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
          </label>
        </div>
        <app-language-container [(languageContents)]="wrapper.languageContents"
          (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)"
          [IsShowAllLanguages]="true"></app-language-container>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary en"
            (click)="onAction(1)">{{localService.languageContent.common.save}}</button>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 10px;">
      <div class="col-sm-12">
        <button type="button" class="btn btn-primary en" style="float: right;font-family: EnglishFont !important;"
          (click)="onAction(2)">Update all the guide contents to all the languages</button>
        <button type="button" class="btn btn-primary en" style="float: right;margin-right: 5px; font-family: EnglishFont !important;"
          (click)="onAction(3)">Update values for search</button>
      </div>
    </div>
  </div>
</div>